
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("dPS3E"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("iF4hT"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("dPS3E", function(module, exports) {

let $a129f88ad1bb7bc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a129f88ad1bb7bc0$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("iF4hT", function(module, exports) {

let $d95f61be5f4ee92c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d95f61be5f4ee92c$var$load("kT6dz"),
    $d95f61be5f4ee92c$var$load("diUSq"),
    $d95f61be5f4ee92c$var$load("XbUoB"),
    $d95f61be5f4ee92c$var$load("iUz8S"),
    $d95f61be5f4ee92c$var$load("gbejv"),
    $d95f61be5f4ee92c$var$load("GD9EA"),
    $d95f61be5f4ee92c$var$load("7TnhR"),
    $d95f61be5f4ee92c$var$load("hUbK8"),
    $d95f61be5f4ee92c$var$load("eSqZD"),
    $d95f61be5f4ee92c$var$load("2PFjC"),
    $d95f61be5f4ee92c$var$load("gwGEC"),
    $d95f61be5f4ee92c$var$load("l5nRU"),
    $d95f61be5f4ee92c$var$load("fcAaN"),
    $d95f61be5f4ee92c$var$load("6GBKZ"),
    $d95f61be5f4ee92c$var$load("28xpM"),
    $d95f61be5f4ee92c$var$load("1rM9D"),
    $d95f61be5f4ee92c$var$load("3cN9G"),
    $d95f61be5f4ee92c$var$load("7oMW2"),
    $d95f61be5f4ee92c$var$load("j3345"),
    $d95f61be5f4ee92c$var$load("2J2X1"),
    $d95f61be5f4ee92c$var$load("do0Fh"),
    $d95f61be5f4ee92c$var$load("1Gr4q"),
    $d95f61be5f4ee92c$var$load("4RsKm"),
    $d95f61be5f4ee92c$var$load("7oAXW"),
    $d95f61be5f4ee92c$var$load("3RQq6"),
    $d95f61be5f4ee92c$var$load("iOfkQ"),
    $d95f61be5f4ee92c$var$load("dxcsb"),
    $d95f61be5f4ee92c$var$load("9ZFGK"),
    $d95f61be5f4ee92c$var$load("2hLAI"),
    $d95f61be5f4ee92c$var$load("dCilB"),
    $d95f61be5f4ee92c$var$load("1T8H1"),
    $d95f61be5f4ee92c$var$load("fyKFO"),
    $d95f61be5f4ee92c$var$load("d9sg7"),
    $d95f61be5f4ee92c$var$load("l0N35"),
    $d95f61be5f4ee92c$var$load("cmmpX"),
    $d95f61be5f4ee92c$var$load("ekVH8"),
    $d95f61be5f4ee92c$var$load("5lBmr"),
    $d95f61be5f4ee92c$var$load("j6n20"),
    $d95f61be5f4ee92c$var$load("gpnR1"),
    $d95f61be5f4ee92c$var$load("cyTuQ"),
    $d95f61be5f4ee92c$var$load("jqoep"),
    $d95f61be5f4ee92c$var$load("6wr18"),
    $d95f61be5f4ee92c$var$load("59hV4"),
    $d95f61be5f4ee92c$var$load("8zMmc"),
    $d95f61be5f4ee92c$var$load("4x9Jx"),
    $d95f61be5f4ee92c$var$load("a8glC"),
    $d95f61be5f4ee92c$var$load("dGhn8"),
    $d95f61be5f4ee92c$var$load("5omeF"),
    $d95f61be5f4ee92c$var$load("ffEVr"),
    $d95f61be5f4ee92c$var$load("gzrfp"),
    $d95f61be5f4ee92c$var$load("2EIkU"),
    $d95f61be5f4ee92c$var$load("ddvkk"),
    $d95f61be5f4ee92c$var$load("3upHR"),
    $d95f61be5f4ee92c$var$load("dds2B"),
    $d95f61be5f4ee92c$var$load("35uOz"),
    $d95f61be5f4ee92c$var$load("Wowvf"),
    $d95f61be5f4ee92c$var$load("eRhBr"),
    $d95f61be5f4ee92c$var$load("hZ2FX"),
    $d95f61be5f4ee92c$var$load("hhss7"),
    $d95f61be5f4ee92c$var$load("7EorR"),
    $d95f61be5f4ee92c$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.2728e5ea.js.map
